import { useRef, useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import Tabs from 'approot/shared/tabs/tabs';
import { useSortableScrollManager } from 'approot/shared/sortable/sortable.hooks';
import { SORTABLE_CARD } from 'approot/shared/sortable/sortable.constants';
import { SettingsProps } from './multiple-choice-settings.constants';
import MultipleChoiceSettingsContent from './multiple-choice-settings-content';
import MultipleChoiceSettingsSolution from './multiple-choice-settings-solution';
import MultipleChoiceSettingsLayout from './multiple-choice-settings-layout';
import * as Styled from './multiple-choice-settings.style';

const MultipleChoiceSettingsTabs = (props: SettingsProps) => {
  const { onCloseChildDrawer } = props;
  const { closeDrawer } = useActivityBuilderContext();
  const ref = useRef<HTMLDivElement | null>(null);

  const [tab, setTab] = useState<number>(1);

  useSortableScrollManager(ref, [SORTABLE_CARD]);

  const onClose = onCloseChildDrawer ? onCloseChildDrawer : closeDrawer;
  return (
    <ActivityBuilderDrawerWrapper onCloseByEscape={onClose}>
      <ActivityBuilderDrawerHeader
        title="Multiple Choice"
        isBack={!!onCloseChildDrawer}
        onClose={onClose}
      />
      <Styled.MultipleChoiceTabs>
        <Tabs
          ariaDescription="Multiple choice setting tab options"
          contentPanelId="content"
          options={[
            { label: 'Content', value: 1 },
            { label: 'Solution', value: 2 },
            { label: 'Layout', value: 3 },
          ]}
          activeTab={tab}
          onSelect={tab => setTab(tab.value as number)}
        />
      </Styled.MultipleChoiceTabs>

      <ActivityBuilderDrawerContent ref={ref}>
        <div id="content" tabIndex={-1}>
          {tab === 1 && <MultipleChoiceSettingsContent {...props} />}
          {tab === 2 && <MultipleChoiceSettingsSolution {...props} />}
          {tab === 3 && <MultipleChoiceSettingsLayout {...props} />}
        </div>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

const MultipleChoiceSettings = (props: SettingsProps) => (
  <FileDropperContextProvider>
    <MultipleChoiceSettingsTabs {...props} />
  </FileDropperContextProvider>
);

export default MultipleChoiceSettings;
